// @flow
import React, { type Node } from 'react';
import { MdCloudUpload } from 'react-icons/md';
import './EstimateBoxTemplate.scss';
import EstimateGuide from '../EstimateGuide';

type Props = {
  children: Node,
};

const guideDescriptions = [
  '견적요청서(파일명)를 다운로드 합니다',
  '견적 가능한 품목에 대하여 견적서를 작성합니다. (견적서 양식은 자유)',
  '작성한 견적서를 업로드합니다',
  '업로드한 견적서는 구매자에게 바로 전송됩니다',
];

const EstimateBoxTemplate = ({ children }: Props) => (
  <div className="EstimateBoxTemplate">
    <div className="main">
      {/* <h2>
        <MdCloudUpload />
        견적서 등록
      </h2>
      <h4>
        견적서를 등록할 수 있는 페이지입니다. <br />
        견적서를 등록하시면 해당 견적을 요청한 구매자에게 견적서가 발송됩니다.
      </h4>
      <EstimateGuide descriptions={guideDescriptions} /> */}
      {children}
    </div>
  </div>
);

export default EstimateBoxTemplate;



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateBoxTemplate/EstimateBoxTemplate.js